import { api } from "./api.v2";

const BASE_URL = "/pdv/crm-gestante/mensagens";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  listar: async () => {
    return await api.get(BASE_URL);
  },

  buscarPorId: async (id) => {
    return await api.get(`${BASE_URL}/${id}`);
  },

  criar: async (payload) => {
    return await api.post(BASE_URL, payload);
  },

  atualizar: async (id, payload) => {
    return await api.patch(`${BASE_URL}/${id}`, payload);
  },

  deletar: async (id) => {
    return await api.delete(`${BASE_URL}/${id}`);
  },
};
